import Authorization from "components/routing/Authorization"
import {Role} from "util/role"
import {Link, Navigate, Outlet, Route, Routes} from "react-router-dom"
import GraphContainer from "components/graph/GraphContainer"
import {Button, Form, Layout, Menu} from "antd"
import Label from "components/Label"
import DoctorsPatientOverview from "components/doctor/DoctorsPatientOverview"
import PatientDetails from "components/doctor/PatientDetails"
import SessionDetails from "components/doctor/SessionDetails"
import MedicalForm from "components/doctor/MedicalForm"
import PreferencesForm from "components/patient/PreferencesForm"
import SdmaModal from "components/SdmaModal"

const {Sider, Content} = Layout

export default function DoctorPage() {
	const [form] = Form.useForm()
	return (
		<Authorization roles={Role.Doctor}>
			<Routes>
				<Route path="" element={<DoctorContent/>}>
					<Route path="" element={<Navigate to="patients"/>}/>
					<Route path="patients/">
						<Route path="" element={<DoctorsPatientOverview/>}/>
						<Route path=":username" element={<PatientDetails/>}/>
					</Route>
					<Route path="session/:sessionId/">
						<Route path="" element={<SessionDetails/>}/>
						<Route path="medicalInfo" element={<MedicalForm/>}/>
						<Route path="preferences" element={<div>
							<PreferencesForm form={form} doctor={true}/>
							<Button className="continue-button" form="patientPreferences" key="submit" htmlType="submit">
								<Label id="save"/>
							</Button>
						</div>}/>
					</Route>
				</Route>
			</Routes>
		</Authorization>
	)
}

function DoctorContent() {
	return (
		<Layout className="content_container">
			<Sider className="sider">
				<Menu className="sider">
					<Menu.Item key="patients">
						<Link to="patients">
							<Label id="doctor.sider.patients"/>
						</Link>
					</Menu.Item>
					<SdmaModal name={<Label id="admin.sider.data.graphs"/>} modalClass="comparison" buttonClass="ant-btn-text ant-btn-lg">
						<GraphContainer/>
					</SdmaModal>
				</Menu>
			</Sider>
			<Content className="content_container">
				<Outlet/>
			</Content>
		</Layout>
	)
}
